import * as React from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "components/common";
import { useFetchCache } from "components/lookup-tables/hooks/useLookupTablesAPI";
import CacheShow from "./cache-show";
function CacheView() {
  const { cacheIdOrName } = useParams();
  const { cache, loadingCache } = useFetchCache(cacheIdOrName);
  if (loadingCache) return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading cache details" });
  return /* @__PURE__ */ React.createElement(CacheShow, { cache });
}
export default CacheView;
